import React, { useEffect, useState } from "react";
import "./customTabs.css"; // 导入自定义样式文件
import FilterStyle from "./filter.module.css";

import { Button, Col, Form, Input, Row, Upload, Select, Tabs, Tooltip } from "antd";
import { UploadOutlined,EllipsisOutlined } from "@ant-design/icons";
import HeatEchart from "./Echarts/Heat";

import SheetCom from "./Echarts/Sheet";
import http from "../../../../../utils/http";
import { fileSelect,fileSelectoption } from './filterselect'
import TissueOptions from './tissue'

function Filter() {
  const [textValue, setTextValue] = useState("");
  const [IsShow, setIsShow] = useState(false);
  const [form] = Form.useForm();
 const [TimeOptions, setTimeOptions] = React.useState([])
  const [TissueOptions2, setTissueOptions] = React.useState([])
  useEffect(() => {
    form.setFieldsValue({
      gene_ids: textValue,
    }); // 初始化时更新文本域的值
  }, [textValue]);
  const [HeatData, setHeatData] = useState({});
  const [SheetData, setSheetData] = useState({});

  const TagsItems = [
   
    {
      key: "2",
      label: <p style={{ fontWeight: "bold" }}>Heat map</p>,
      children: <HeatEchart heatmap={HeatData}  />,
    },
   
    {
      key: "4",
      label: <p style={{ fontWeight: "bold" }}>Data sheet</p>,
      children: <div>
       
        <SheetCom List={SheetData}  />
      </div>,
    },
  ];
  const onChange = (key) => {
    console.log(key);
  };
  const IsShowDetail = () => {
    if (IsShow) {
      return (
        <div className={FilterStyle.Detail_div}>
          <Tabs
            type="card"
            style={{ marginLeft: "50px", marginTop: "30px", width: "95%" }}
            defaultActiveKey="1"
            items={TagsItems}
            onChange={onChange}
          />
        </div>
      );
    }
  };



  const StaghandleChange = (value) => {
    console.log(`selected ${value}`);
  };
const [IsSubmitLoading, setIsSubmitLoading] = useState(false);
  const onFinish = (values) => {
    setIsSubmitLoading(true);
    console.log("Success:", values);
    const newFormData = new FormData();

    let TempleObject={
      gene_ids:values.SN === undefined ? values.gene_ids : values.SN.file,
      data_type:values.data_type,
      project:values.project,
      time:values.time
    }
    Object.keys(TempleObject).forEach((key) => {
      newFormData.append(key, TempleObject[key]);
    });
    http
      .post("/api/trans/rna/", newFormData)
      .then((res) => {
    setIsShow(true);
    setIsSubmitLoading(false);

        console.log(res);
        setHeatData(res.heatmap_data)
        setSheetData(res.table_data)
      })
      .catch((err) => {
    setIsSubmitLoading(false);

      });
  };
  const onReset = () => {
    form.setFieldsValue({ gene_ids: "", data_type: "", project: [], time: [] });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const UploadFn = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      let content = event.target.result;

      setTextValue(content);
      form.setFieldsValue({ username: content }); // 手动更新文本域的值
    };
    reader.readAsText(file);
    return false;
  };
  return (
    <div className={FilterStyle.filter_app}>
      <div className={FilterStyle.filter_Form}>
        <Form
          form={form}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ marginLeft: "100px" }}
        >
          <Row>
            <Col flex="auto">
            <Form.Item
                name="project"
                // rules={[
                //   { required: true, message: "Please Select your Tlssue!" }, // 设置必填规则
                // ]}
                colon={false}
                label={
                  <span
                    style={{
                      fontWeight: "bold",
                      marginRight: "20px",
                      marginLeft: "10px",
                    }}
                  >
                    Project
                  </span>
                }
              >
                <Select
                  mode="multiple"
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  maxTagCount={2}
                  maxTagPlaceholder={(omittedValues) => (
                    <Tooltip
                      overlayStyle={{
                        pointerEvents: "none",
                      }}
                      title={omittedValues.map(({ label }) => label).join(", ")}
                    >
                      <span>Hover Me</span>
                    </Tooltip>
                  )}
                  placeholder="Please select"
                   options={fileSelectoption}
                  filterOption={fileSelect} 
                  onChange={(e)=>{
                    console.log(e)
                    const templeArrtime=[]
                    const templeArrtissue=[]
                    e.map(v=>{
                      templeArrtime.push(...TissueOptions[v].time)
                      templeArrtissue.push(...TissueOptions[v].tissue)
                    
                    })
                    setTimeOptions(templeArrtime)
                    setTissueOptions(templeArrtissue)
                  }}
                />
              </Form.Item>



             
            </Col>
            <Col flex="100px"></Col>
          </Row>
          <Row>
            <Col flex="auto">
            <Form.Item
                colon={false}
                name="data_type"
                label={
                  <span style={{ fontWeight: "bold", marginRight: "30px" }}>
                    Method
                  </span>
                }
                rules={[
                  { required: true, message: "Please Select Type!" }, // 设置必填规则
                ]}
              >
                <Select>
                  <Select.Option value="fpkm">FPKM</Select.Option>
                  <Select.Option value="tpm">TPM</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col flex="100px"></Col>
          </Row>
          <Row>
            <Col flex="auto">
            <Form.Item
                rules={[
                  { required: true, message: "Please Input GeneID!" }, // 设置必填规则
                ]}
                label={
                  <span style={{ fontWeight: "bold", marginRight: "15px" }}>
                    GeneID
                  </span>
                }
                name="gene_ids"
                colon={false}
              >
                <Input.TextArea
                  value={textValue}
                  onChange={(e) => setTextValue(e.target.value)}
                />
              </Form.Item>
              <Form.Item
                name="SN"
                style={{
                  paddingLeft: "75px",
                  padding: "0",
                  marginLeft: "95px",
                  marginTop: "-25px",
                  background: "transparent",
                }}
              >
                <Upload
                  name="logo"
                  action="/upload.do"
                  beforeUpload={UploadFn}
                  listType="text"
                  onRemove={() => {
                    setTextValue("");
                  }}
                >
                  <Button
                    style={{
                      border: "none",
                      padding: "0",
                      margin: "0",
                      background: "transparent",
                    }}
                    icon={<UploadOutlined />}
                  >
                    Click to upload
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col flex="100px"></Col>
          </Row>
          <Row>
            <Col flex="auto">
              <Form.Item
                name="tissue"
                colon={false}
                rules={[
                  { required: true, message: "Please Select your Tissue!" }, // 设置必填规则
                ]}
                label={
                  <span style={{ fontWeight: "bold", marginRight: "25px" }}>
                    Tissue
                  </span>
                }
              >
                <Select
                  mode="multiple"
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  placeholder="Please select"
                  onChange={StaghandleChange}
                  options={TissueOptions2}
                />
              </Form.Item>
            </Col>
            <Col flex="100px"></Col>
          </Row>
          <Row>
            <Col flex="auto">
              <Form.Item
                name="time"
                colon={false}
                rules={[
                  { required: true, message: "Please Select your Time!" }, // 设置必填规则
                ]}
                label={
                  <span style={{ fontWeight: "bold", marginRight: "25px" }}>
                    Time
                  </span>
                }
              >
                <Select
                  mode="multiple"
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  placeholder="Please select"
                  onChange={StaghandleChange}
                  options={TimeOptions}
                />
              </Form.Item>
            </Col>
            <Col flex="100px"></Col>
          </Row>
          <Row>
            <Col span={12} style={{ display: "flex", alignItems: "center" }}>
              <Button
                style={{
                  marginLeft: "87px",
                  border: "none",
                  color: "#2ADD9D",
                  fontWeight: "bold",
                  marginTop: "-30px",
                }}
                onClick={() => {
                  form.setFieldsValue({
                    gene_ids:
                      "Chr01.g00051.m1\nChr01.g00053.m1\nChr01.g00054.m2\nChr01.g00055.m1\nChr01.g00056.m1\nChr01.g00060.m1\nChr01.g00063.m1\nChr01.g00064.m1\nChr01.g00065.m1\nChr01.g00066.m1",
                      data_type: ['fpkm'],
                      project: ["P21", "P18", "P15"],
                      tissue: ["Cotyledon","Plumule"], // 自动设置 tissue 为 Plumule
                    time: [
                      "the 6th day after pollination",
                      "the 9th day after pollination",
                      "the 12th day after pollination",
                    ],
                  }); // 初始化时更新文本域的值
                  setTextValue("Chr01.g00051.m1\nChr01.g00053.m1\nChr01.g00054.m2\nChr01.g00055.m1\nChr01.g00056.m1\nChr01.g00060.m1\nChr01.g00063.m1\nChr01.g00064.m1\nChr01.g00065.m1\nChr01.g00066.m1")
                }}
              >
                example
              </Button>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Form.Item
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "100px",
                }}
              >
                <Button
                  style={{ margin: "0 20px", background: "#11A07A" }}
                  type="primary"
                  htmlType="submit"
                  loading={IsSubmitLoading}
                >
                  search
                </Button>
                <Button htmlType="button" onClick={onReset}>
                  Reset
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
      {IsShowDetail()}
    </div>
  );
}

export default Filter;
